"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParkingTypes = exports.Facilities = exports.CyclabilityZoneStats = exports.CyclabilityZoneBNSCStats = void 0;
exports.toDateKey = toDateKey;
let Facilities = exports.Facilities = /*#__PURE__*/function (Facilities) {
  Facilities["Cycleways"] = "cycleways";
  Facilities["Greenways"] = "greenways";
  Facilities["Lanes"] = "lanes";
  Facilities["Opposites"] = "opposites";
  Facilities["SharedBusways"] = "sharedBusways";
  Facilities["MixedFacilities"] = "mixedfacilities";
  return Facilities;
}({});
let ParkingTypes = exports.ParkingTypes = /*#__PURE__*/function (ParkingTypes) {
  ParkingTypes["Arch"] = "arch";
  ParkingTypes["Free"] = "free";
  ParkingTypes["Locked"] = "locked";
  ParkingTypes["Private"] = "private";
  ParkingTypes["Rack"] = "rack";
  ParkingTypes["Secure"] = "secure";
  ParkingTypes["Sheltered"] = "sheltered";
  return ParkingTypes;
}({});
class CyclabilityZoneStats {
  constructor(date, distances) {
    this.date = date;
    this.distances = distances;
    this.dateAsKey = toDateKey(date);
  }
}
exports.CyclabilityZoneStats = CyclabilityZoneStats;
class CyclabilityZoneBNSCStats {
  constructor(date, slots) {
    this.date = date;
    this.slots = slots;
    this.dateAsKey = toDateKey(date);
  }
}
exports.CyclabilityZoneBNSCStats = CyclabilityZoneBNSCStats;
function toDateKey(date) {
  return date.format('YYYY-MM');
}